import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { setSelectedMenu } from "../../redux/actions/actions";
import { BaseUrlReports } from "../../container/BaseUrl/BaseUrl";
import axios from "axios";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import moment from "moment";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";

import { Spinner } from "react-bootstrap";
import { TiWarningOutline } from "react-icons/ti";
const mapStateToProps = (state) => {
  return {
    selectedMenu: state.contactListData.selectedMenu,
  };
};
const Weeklyreport = (props) => {
  const selectAgentRef = useRef(null);
  const selectSkillsetRef = useRef(null);
  const selectDispositionRef = useRef(null);

  var someDate = new Date();
  var date = someDate.setDate(someDate.getDate());
  var defaultValue = new Date(date).getFullYear();
  console.log(defaultValue);

  var someDate = new Date();
  var currentMonth = someDate.getMonth() + 1; // Adding 1 to adjust the month number to start from 1

  console.log(currentMonth);

  const [fromYear, setFromYear] = useState(defaultValue);

  const animatedComponents = makeAnimated();
  const [apiCallsMade, setApiCallsMade] = useState(false);
  const [showfilter, setShowFilter] = useState(false);
  const [agentlistdata, setAgentlistdata] = useState([]);
  const [skillsetdata, setSkillsetdata] = useState([]);
  const [disposition, setDisposition] = useState([]);
  const [fromdate, setFromdate] = useState(defaultValue);
  const [todate, setTodate] = useState(defaultValue);
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState(0);
  const [agentspinner, setagentspinner] = useState(false);
  const [selectedMonth, setSelectedMonth] = useState(currentMonth);

  const [agentlogindatalist, setAgentLoginDataList] = useState([]);

  const [selectedagent, setSelectedagent] = useState([]);

  const handleMonthChange = (e) => {
    console.log("month", e.target.value);
    setSelectedMonth(e.target.value); // Update selectedMonth state with the value selected by the user
  };

  const handleYearChange = (e) => {
    console.log("year", e.target.value);
    setFromYear(e.target.value);
  };

  const yearOptions = [];
  for (let year = new Date().getFullYear(); year >= 1900; year--) {
    yearOptions.push(
      <option key={year} value={year}>
        {year}
      </option>
    );
  }

  const handelShowFilter = () => {
    setShowFilter(true);
  };
  const handelCloseFilter = () => {
    setShowFilter(false);
  };

  const optionsAgent = agentlistdata.map((agent) => ({
    value: agent.agent_id,
    label: agent.agent_name,
  }));

  // const optionsAgent = agentlistdata.map((option)=>{
  //     console.log(option)
  // })
  const optionsSkillset = skillsetdata.map((skillset) => ({
    value: skillset,
    label: skillset,
  }));

  const optionsDisposition = disposition.map((dispos) => ({
    value: dispos,
    label: dispos,
  }));

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      fontSize: "13px",
    }),
  };

  useEffect(() => {
    if (!apiCallsMade) {
      agentCallDetailsReportDataAgentList();
      setApiCallsMade(true);
    }
  }, [apiCallsMade]);

  useEffect(() => {
    WeeklyReport();
  }, [page]);

  const WeeklyReport = async () => {
    setApiCallsMade(true);
    setagentspinner(true);
    await axios
      .post(
        BaseUrlReports + "api/weekly_report",
        {
          year: fromYear ? fromYear : defaultValue,
          month: selectedMonth ? selectedMonth : currentMonth,
          agent_id: selectedagent,
          tenent_id: localStorage.getItem("TenantId"),
          offset: page == 1 ? 0 : (page - 1) * 10,
          limit: 10,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then((res) => {
        console.log("res", res);
        if (res.data) {
          setagentspinner(false);
          console.log(res.data.callsCountPerAgentPerDate);
          setAgentLoginDataList(res.data.data);
          setPagination(res.data.num);
        }
      })

      .catch((error) => {
        setagentspinner(false);
        console.log(error);
      });
  };

  const handleChange = (event, value) => {
    console.log(value);
    setPage(value);
  };

  const agentCallDetailsReportDataAgentList = async () => {
    setApiCallsMade(true);
    await axios
      .post(
        BaseUrlReports + "api/agents",
        {
          tenent_id: localStorage.getItem("TenantId"),
          // tenent_id: 'a3dc14bd-fe70-4120-8572-461b0dc866b5'
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then((res) => {
        if (res.data) {
          setAgentlistdata(res.data.agents);
        }
      })

      .catch((error) => {
        console.log(error);
      });
  };

  const handleSelectAgentChange = (selectedOptions) => {
    const value = selectedOptions.map((option) => option.value);
    setSelectedagent(value);
  };

  const resetButton = () => {
    selectAgentRef.current.clearValue();
    setTodate("");
    setFromdate("");
    handelCloseFilter();
  };

  return (
    <>
      <div
        class={
          showfilter
            ? "offcanvas offcanvas-end show"
            : "offcanvas offcanvas-end"
        }
        tabindex="-1"
        id="offcanvasRight"
        aria-labelledby="offcanvasRightLabel"
      >
        <div class="offcanvas-header">
          <h5 class="offcanvas-title" id="offcanvasRightLabel">
            Filter
          </h5>
          <button
            onClick={handelCloseFilter}
            type="button"
            class="btn-close"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          ></button>
        </div>
        <div class="offcanvas-body">
          <label htmlFor="exampleInputfromdate" className="form-label">
            Select Year <small className="text-danger">*</small>
          </label>
          <select
            value={fromYear}
            onChange={handleYearChange}
            className="form-control form-control-lg"
            id="exampleInputfromdate"
          >
            <option value="">--Select Year--</option>
            {yearOptions}
          </select>

          <label htmlFor="exampleInputfromdate" className="form-label">
            Select Month <small className="text-danger">*</small>
          </label>
          <select
            value={selectedMonth}
            onChange={handleMonthChange}
            className="form-control form-control-lg"
            id="exampleInputfromdate"
          >
            <option value="">--Select Month--</option>
            <option value="1">January</option>
            <option value="2">February</option>
            <option value="3">March</option>
            <option value="4">April</option>
            <option value="5">May</option>
            <option value="6">June</option>
            <option value="7">July</option>
            <option value="8">August</option>
            <option value="9">September</option>
            <option value="10">October</option>
            <option value="11">November</option>
            <option value="12">December</option>
          </select>

          <div class="mb-3">
            <label for="exampleInputfromdate" class="form-label">
              Agent <small class="text-danger">*</small>
            </label>
            <Select
              ref={selectAgentRef}
              closeMenuOnSelect={true}
              components={animatedComponents}
              isMulti
              options={optionsAgent}
              placeholder="Select Agent"
              styles={customStyles}
              onChange={handleSelectAgentChange}
            />
          </div>
        </div>
        {/* <div class="offcanvas-sub-btn mb-1 d-flex justify-content-between ">
                    <button onClick={handelCloseFilter} type="button" data-bs-dismiss="offcanvas" aria-label="Close"
                        class="btn btn-secondary btn-sm mx-1">Close</button>
                    <button onClick={resetButton} type="button" class="btn btn-warning btn-sm flex-fill mx-1" >Reset</button>
                    <button onClick={() => { agentLogindatalist(); handelCloseFilter() }} type="button" class="mx-1 btn btn-primary btn-sm flex-fill">Submit</button>
                </div> */}

        <div class="offcanvas-sub-btn d-flex justify-content-between mb-1">
          <button
            onClick={handelCloseFilter}
            type="button"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
            class="btn btn-secondary btn-sm mx-1 flex-fill"
          >
            Close
          </button>
          <button
            onClick={resetButton}
            type="button"
            class="btn btn-sm btn-warning mx-1  flex-fill"
          >
            Reset
          </button>
          <button
            onClick={() => {
              setPage(1);
              WeeklyReport();
              handelCloseFilter();
            }}
            type="button"
            class=" mx-1 btn-sm btn btn-primary flex-fill"
          >
            Submit
          </button>
        </div>
      </div>

      <div class="sub-wapper bg-light" id="mainid">
        <div class="container-fluid">
          <div class="pt-3">
            <div
              class="sub-main card border-0 rounded-0"
              id="menu1"
              style={{ height: "98vh" }}
            >
              <div class="card-header rounded-0 shadow-sm border-0 bg-white d-flex justify-content-between align-content-center">
                <span className="fw-bold">Weekly Reports</span>
                <div>
                  <button
                    type="button"
                    class="btn btn-outline-primary rounded-0 fs-13 me-2"
                  >
                    <i class="fa-solid fa-cloud-arrow-down mx-1"></i>
                    Download Report
                  </button>
                  <button
                    onClick={handelShowFilter}
                    type="button"
                    class="btn btn-primary rounded-0 fs-13"
                  >
                    <i class="fa-solid fa-filter mx-1"></i>
                    Filter
                  </button>
                  <button
                    type="button"
                    class="btn btn-outline-primary mx-2 rounded-0 fs-13 me-2"
                    onClick={() => {
                      props.setSelectedMenu("ReportMenu");
                    }}
                  >
                    <i class="fa-solid fa-arrow-left mx-1"></i>
                    Back
                  </button>
                </div>
              </div>
              <div
                class="card-body px-1"
                style={{
                  minWidth: "100%",
                  overflowX: "auto",
                  overflowY: "clip",
                }}
              >
                <div>
                  <div class="table-responsive h-75vh">
                    <table
                      class="table table-hover"
                      style={{ fontSize: "14px" }}
                    >
                      <thead>
                        <tr>
                          <th scope="col">Agent Name</th>
                          <th scope="col">Answered Count</th>
                          {/* <th scope="col">ISO Week</th> */}
                          <th scope="col">Maximum Answered Time</th>
                          <th scope="col">Total Answered Time</th>
                          <th scope="col">Week Start</th>
                          <th scope="col">Week End</th>
                        </tr>
                      </thead>
                      <tbody>
                        {agentlogindatalist && agentlogindatalist.length > 0 ? (
                          agentlogindatalist.map((item) => {
                            return (
                              <tr>
                                <td>
                                  {item.Agent_name ? item.Agent_name : "--"}
                                </td>
                                <td>
                                  {item.Answered_count
                                    ? item.Answered_count
                                    : "--"}
                                </td>
                                {/* <td>{item.ISO_Week ? item.ISO_Week : '--'}</td> */}
                                <td>
                                  {item.Maximum_answered_time
                                    ? item.Maximum_answered_time
                                    : "--"}
                                </td>
                                <td>
                                  {item.Total_answered_time
                                    ? item.Total_answered_time
                                    : "--"}
                                </td>
                                <td>
                                  {item.Week_start ? item.Week_start : "--"}
                                </td>
                                <td>{item.Week_end ? item.Week_end : "--"}</td>
                              </tr>
                            );
                          })
                        ) : (
                          <div
                            className="d-flex justify-content-center align-items-center position-absolute"
                            style={{ minHeight: "400px", left: "50%" }}
                          >
                            <div
                              className="d-flex"
                              style={{ flexDirection: "column" }}
                            >
                              {agentspinner ? (
                                <>
                                  <Spinner
                                    animation="border"
                                    variant="primary"
                                  />
                                  <span
                                    className="position-relative mt-2"
                                    style={{ left: "-10px" }}
                                  >
                                    Loading...
                                  </span>
                                </>
                              ) : (
                                <>
                                  <TiWarningOutline
                                    size={30}
                                    className="mx-auto text-muted"
                                  />
                                  <span className="fw-bold text-muted">
                                    No Data Found
                                  </span>
                                </>
                              )}
                            </div>
                          </div>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <div class="card-footer rounded-0  bg-white d-flex justify-content-end align-content-center">
                <nav aria-label="Page navigation example">
                  <Stack spacing={2}>
                    <Pagination
                      onChange={handleChange}
                      count={Math.ceil(pagination / 10)}
                      page={page}
                      color="primary"
                      variant="outlined"
                      shape="rounded"
                      size="small"
                    />
                  </Stack>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default connect(mapStateToProps, {
  setSelectedMenu,
})(Weeklyreport);
